<template>

    <div class="container-fluid">

        <div class="login-page">

            <div class="login-container">

                <div class="w-100">
                    <a href="/"><img src="/images/card/logo.svg" class="logo"></a>
                </div>

                <div class="w-100">
                    <div>
                        <h1 class="mb-2">Begär ett nytt lösenord</h1>
                        <p class="mb-8">Begär en återställningslänk för att ändra ditt lösenord. Länken är aktiv i 24 timmar.</p>
                    </div>

                <div class="alert alert-success" v-if="success">
                        En återställningslänk har skickats till dig.
                    </div>

                    <form @submit.prevent="posterPost">

                        <input-text
                            type="tel"
                            name="phone"
                            label="Mobilnummer"
                            form-group-class="mb-4"
                            v-model="phone"
                            :float-label="true"
                        />

                        <button class="btn btn-primary float-end" :disabled="success || poster.submitted">
                            <span class="spinner-border spinner-border-sm" v-if="!success"></span>
                            <span>Skicka återställningslänk</span>
                        </button>

                    </form>
                </div>

                <div class="forgot-link-container"></div>

            </div>

        </div>

    </div>

</template>

<script>

import poster from '../../../../shared/mixins/poster'

export default {

    mixins: [
        poster
    ],

    data () {
        return {
            phone: '',
            success: false
        }
    },

    computed: {
        posterUrl () {
            return '/password/forgot'
        },
        posterData () {
            return {
                phone: this.phone
            }
        }
    },

    methods: {
        posterSuccess () {
            this.success = true
        }
    }

}
</script>
